import { render } from "./FinancialYearComponent.vue?vue&type=template&id=220b4e69&ts=true"
import script from "./FinancialYearComponent.vue?vue&type=script&lang=ts"
export * from "./FinancialYearComponent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__